import Store from 'store/store';

function onPageView(pageId) {
	if (/^i-am-living-proof(-|$)/.test(pageId)) {
		loadFB();
		fbq('init', '354649876183377');
		fbq('track', 'PageView');
	}
}

Store.on('LANDING', ({ page }) => onPageView(page));
Store.on('SET_ACTIVE_PAGE', onPageView);

function loadFB() {
	!function(f,b,e,v,n,t,s)
	{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
	n.callMethod.apply(n,arguments):n.queue.push(arguments)};
	if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
	n.queue=[];t=b.createElement(e);t.async=!0;
	t.src=v;s=b.getElementsByTagName(e)[0];
	s.parentNode.insertBefore(t,s);}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
}